export default __webpack_public_path__ + "static/media/brainster_blog_mobile_shapes.76e71ea2.svg";